import React from 'react';
import './index.less';
import { getCurrencyIcon } from '../../../../../../../../../../shared/js/get-currency-icon';

function PayoutAmountWithPercentWrapper({
	percent, isPercentShouldBeShown, fee, isFeeShouldBeShown, currency, children
}) {
	return (
		<div className='payout-table--body--amount-wrapper'>
			{children}
			<span className='payout-table--body--percent'>
				{isPercentShouldBeShown && (
					`${percent} % `
				)}
				{isFeeShouldBeShown && (
					`${fee} ${getCurrencyIcon(currency)} `
				)}
			</span>
		</div>
	);
}

export default PayoutAmountWithPercentWrapper;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/payouts/components/table/components/payout-body/components/payout-amount-with-percent-wrapper/index.js